module.exports = "<img src=\"/assets/images/thumb/resto/interieur.jpg\" alt=\"interieur\" class=\"interieur\" />\n<p>\n  Au restaurant, Valérie vous propose une cuisine traditionnelle et goûteuse issue de produits locaux.\n</p>\n\n<img src=\"/assets/images/thumb/resto/plat1.jpg\" alt=\"plat\" class=\"plat plat1\" />\n<p>\n  Restaurant cuisine traditionnelle avec menu unique à 12,50€.\n</p>\n<p>Ouvert tous les midis du lundi au vendredi</p>\n<p><a routerLink=\"/repas-groupes\">Le week end restauration possible sur réservation avec une carte élargie</a></p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/repas-ouvriers/repas-ouvriers.component.html
// module id = 600
// module chunks = 1